import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Close, StorefrontOutlined } from "@mui/icons-material";
import DataTable from "shared/components/Tables/DataTable";
import { dashboardTableStyles } from "../../utils/dashboardTableStyles";
import DashboardStatus from "../Cells/DashboardStatus";
import {
  formatDate,
  formatMinutes,
  parentState,
  rawDate,
  recordStatus,
} from "../../utils/dashboardModel";

export default function DashboardDetail({ group, tipo, onClose }) {
  const fullScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const label = tipo === "eds" ? "antenas" : tipo === "peajes" ? "peajes" : "terminales";
  const columns = [
    ...(tipo === "eds"
      ? [
          { Header: "Antena", accessor: "antena" },
          { Header: "Reader", accessor: "reader" },
          { Header: "Ciudad", accessor: "ciudad" },
        ]
      : [{ Header: tipo === "peajes" ? "Peaje / comercio" : "Terminal", accessor: "device" }]),
    { Header: "Última actividad", accessor: "last" },
    { Header: "Promedio", accessor: "average" },
    { Header: "Tiempo sin actividad", accessor: "elapsed" },
    { Header: "Estado reportado", accessor: "rawStatus" },
    { Header: tipo === "peajes" ? "Estado concesión" : "Estado comercio", accessor: "parent" },
    { Header: "Estado", accessor: "status" },
  ];
  const rows = (group?.records || []).map((item) => ({
    antena: item.antena ?? "Sin información",
    reader: item.reader ?? "Sin información",
    ciudad: item.ciudad || "Sin información",
    device: (tipo === "peajes" ? item.comercio : item.terminalname) || "Sin información",
    last: formatDate(rawDate(item, tipo)),
    average: formatMinutes(item.promedio_minutos),
    elapsed: formatMinutes(item.minutos_desde_ultima),
    rawStatus:
      (tipo === "eds"
        ? item.estado_antena
        : tipo === "peajes"
        ? item.estado_comercio
        : item.estado_terminal) || "Sin información",
    parent: parentState(item, tipo) || "Sin información",
    status: <DashboardStatus status={recordStatus(item, tipo)} />,
  }));
  return (
    <Dialog
      open={Boolean(group)}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth={false}
      aria-labelledby="dashboard-detail-title"
      PaperProps={{
        sx: {
          borderRadius: { xs: 0, sm: 3 },
          maxWidth: { xs: "100%", sm: 1680 },
          m: { xs: 0, sm: 2 },
          width: { xs: "100%", sm: "calc(100% - 32px)" },
        },
      }}
    >
      <DialogTitle
        id="dashboard-detail-title"
        sx={{
          px: 3,
          py: 2.5,
          background: "linear-gradient(110deg,#12304d,#175d7a)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <StorefrontOutlined />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            component="span"
            display="block"
            variant="h6"
            color="inherit"
            sx={{ overflowWrap: "anywhere" }}
          >
            {group?.name}
          </Typography>
          <Typography component="span" variant="caption" color="inherit">
            Detalle de {label}
          </Typography>
        </Box>
        <IconButton aria-label="Cerrar detalle" onClick={onClose} sx={{ color: "#fff" }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: { xs: 1.5, sm: 3 } }}>
        {group && (
          <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, py: 2 }}>
            <DashboardStatus status={group.status} />
            <Typography variant="body2">
              {group.active} de {group.total} {label} operativos
            </Typography>
          </Box>
        )}
        <Box sx={dashboardTableStyles}>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            canSearch={false}
            entriesPerPage={{ defaultValue: 10, entries: [5, 10, 25, 50] }}
            showTotalEntries
            noEndBorder
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid", borderColor: "divider" }}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ textTransform: "none", color: "#174b68", borderColor: "#b6c4d4" }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
DashboardDetail.propTypes = {
  group: PropTypes.object,
  tipo: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
